import { ActionTypes } from "../constants/action-types";

const initialState={
    imageData:[],
};

const projectImageReducer=(state=initialState,action)=>{
    switch(action.type){
        case ActionTypes.FETCH_PROJECT_IMAGE:
            return{
                ...state,
                imageData:action.payload,
            };
            default:
                return state;
    }
};
export default projectImageReducer;